export * from './status-cabecalho-pedido-carga.pipe';
